import BrokerWiseCrossAuthLogo from './BrokerWiseCrossAuthLogo';

export default BrokerWiseCrossAuthLogo;
